import { axiosInstance } from '@/modules/shared/lib/axios'
import { ScannerSettingsPayload } from './types'

export function updateScannerSettings(companyId: string, payload: ScannerSettingsPayload) {
  return axiosInstance.post<ScannerSettingsPayload>(
    `/api/${companyId}/configuration/saveScannerConfiguration`,
    payload,
  )
}
